(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(23944);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 20027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var LazyImage = function(_param) {
    var src = _param.src, index = _param.index, width = _param.width, height = _param.height, alt = _param.alt, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "index",
        "width",
        "height",
        "alt"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), blur = ref[0], setBlur = ref[1];
    var getSmallImageSrc = function(src) {
        // Ensure src is a string before calling replace
        if (typeof src === "string") {
            return src.replace(/\b(1980|3840|640|960|360)\b/g, "64");
        }
        return null;
    };
    var isLayout = props.layout === "fill";
    // Filter out srcSet and sizes from props as Next.js Image doesn't support them directly
    // eslint-disable-next-line no-unused-vars
    var srcSet = props.srcSet, sizes = props.sizes, imageProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "srcSet",
        "sizes"
    ]);
    // Only render if src is a valid string
    if (src && typeof src === "string") {
        var blurDataURL = getSmallImageSrc(src);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            width: !isLayout && (width || 590),
            height: !isLayout && (height || 393),
            src: src,
            blurDataURL: blurDataURL,
            placeholder: blurDataURL ? "blur" : "empty",
            className: blur ? "img-blur" : "unblur",
            onLoadingComplete: function() {
                return setBlur(false);
            },
            alt: alt || "Property presentation image ".concat(index)
        }, imageProps));
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (LazyImage);


/***/ }),

/***/ 96143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42998);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34495);




var LineSeparator = function(param) {
    var _width = param.width, width = _width === void 0 ? false : _width, _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: width ? {
            width: width
        } : {},
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__/* .withModifiers */ .i)("separator", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(variant), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LineSeparator);


/***/ }),

/***/ 24447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6644);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34495);
/* harmony import */ var _LazyImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20027);
/* eslint-disable react/prop-types */ 









var CloudflareVideo = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 9562).then(__webpack_require__.bind(__webpack_require__, 69562));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69562)
            ];
        }
    }
});
var Section = function(_param) {
    var children = _param.children, className = _param.className, _variant = _param.variant, variant = _variant === void 0 ? [] : _variant, bg = _param.bg, _video = _param.video, video = _video === void 0 ? false : _video, cloudflare = _param.cloudflare, _separator = _param.separator, separator = _separator === void 0 ? false : _separator, sectionRef = _param.sectionRef, _grayscale = _param.grayscale, grayscale = _grayscale === void 0 ? false : _grayscale, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "variant",
        "bg",
        "video",
        "cloudflare",
        "separator",
        "sectionRef",
        "grayscale"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        ref: sectionRef,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__/* .withModifiers */ .i)("section", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(variant).concat([
            separator && "has-separator",
            bg && "with-bg"
        ]), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default())), className)
    }, props), {
        children: [
            bg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                src: bg,
                priority: true,
                objectPosition: "center",
                objectFit: "cover",
                sizes: "(max-width: 360px) 960px, (max-width: 640px) 960px, (max-width: 1400px) 1400px, 1980px",
                alt: "section background image",
                layout: "fill"
            }),
            (cloudflare || video) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__/* .withModifiers */ .i)("section__video", [
                    grayscale && "grayscale"
                ], (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default())),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CloudflareVideo, {
                        name: "Section presentation video",
                        autoplay: true,
                        loop: true,
                        muted: true,
                        src: cloudflare || video
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section__overlay)
                    })
                ]
            }),
            separator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section__separator)
            }),
            children
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Section);


/***/ }),

/***/ 27895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ getS3Url; }
/* harmony export */ });
/* harmony import */ var lodash_es_isArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27771);
/* harmony import */ var lodash_es_isString__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36378);
/* eslint-disable no-undef */ 

// URL cache to avoid redundant calculations
var urlCache = {};
// Detect mobile once and reuse
var isMobile = false;
var isMobileLandscape = false;
// Set up mobile detection only on client
if (true) {
    // Set this once at module level for initial render
    isMobile = window.innerWidth < 360;
    isMobileLandscape = window.innerWidth >= 360 && window.innerWidth < 640;
    // Update on resize with debouncing
    var resizeTimeout;
    window.addEventListener("resize", function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            var width = window.innerWidth;
            isMobile = width < 360;
            isMobileLandscape = width >= 360 && width < 640;
        }, 200);
    });
}
function getS3Url(url) {
    var variant = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "public", video = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    // Return early if no URL
    if (!url || !(0,lodash_es_isArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(url) && !(0,lodash_es_isString__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(url)) {
        return;
    }
    // For server-side rendering, use largest image
    var isServerSide = "object" === "undefined";
    // Use server defaults or client detection
    var effectiveIsMobile = isServerSide ? false : isMobile;
    var effectiveIsMobileLandscape = isServerSide ? false : isMobileLandscape;
    // Generate a cache key
    var cacheKey = "".concat(url, "-").concat(variant, "-").concat(video, "-").concat(effectiveIsMobile, "-").concat(effectiveIsMobileLandscape);
    // Return cached URL if available
    if (urlCache[cacheKey]) {
        return urlCache[cacheKey];
    }
    var result;
    // Determine which type of URL this is
    if (url.includes("images/") || url.includes("videos/")) {
        result = "https://assets.sxmsir.com/" + url.replace(/ /g, "%20");
    } else if (video) {
        result = "https://customer-".concat("mwbbzmyggbfuda1b", ".cloudflarestream.com/").concat(url, "/manifest/video.m3u8");
    } else {
        // Determine the cloudflare variant to use
        var cloudflareVariant;
        // Server-side: Prioritize provided variant if it exists, otherwise use largest
        if (isServerSide) {
            cloudflareVariant = variant && variant !== "public" && variant !== "" ? variant // Use provided variant if it exists and is not 'public' or empty
             : "1980" // Otherwise use largest variant for server-side
            ;
        } else {
            // Client-side: Use existing responsive logic
            cloudflareVariant = effectiveIsMobile ? 360 : effectiveIsMobileLandscape ? 640 : variant === "public" || variant === "" || !variant ? 960 : variant;
        }
        result = "https://imagedelivery.net/".concat("356b0XxwgMp5GfAe77K8NQ", "/").concat(url, "/").concat(cloudflareVariant);
    }
    // Cache the result
    urlCache[cacheKey] = result;
    return result;
}


/***/ }),

/***/ 51987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _layout_Columns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40050);
/* harmony import */ var _layout_Column__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70539);
/* harmony import */ var _elements_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51524);
/* harmony import */ var _elements_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41197);
/* harmony import */ var _elements_LineSeparator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96143);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87898);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(79697);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _helpers_getS3Url__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27895);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34495);
/* harmony import */ var _providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40670);













var Perks = function(param) {
    var shadowRef = param.shadowRef, data = param.data;
    var ref = (0,_providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_9__/* .useResponsive */ .F)(), isSmallMobile = ref.isSmallMobile, isTablet = ref.isTablet, isMobile = ref.isMobile;
    var hasImage = !!data.image;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Container__WEBPACK_IMPORTED_MODULE_3__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: shadowRef,
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().overlay)
            }),
            isTablet && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Column__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                variant: [
                    "no-padding"
                ],
                spans: isSmallMobile ? 12 : 11,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().title),
                    children: data.title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Columns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_11__/* .withModifiers */ .i)("columns", [
                    !hasImage && "wide"
                ], (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default())),
                variant: [
                    !hasImage && isTablet ? "-align-end" : "-distribute-between"
                ],
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Column__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        spans: isSmallMobile ? 11 : isTablet ? !hasImage ? 10 : 8 : !hasImage ? 12 : 6,
                        children: [
                            !isTablet && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: data.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Columns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                variant: [
                                    !hasImage && (isTablet ? "-align-end" : "-align-center")
                                ],
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Column__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        spans: !hasImage && !isTablet ? 1 : 2,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_LineSeparator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Column__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        spans: !hasImage && !isTablet ? 6 : 10,
                                        children: [
                                            data.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: data.description
                                                }
                                            }),
                                            data.button && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Button__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().button),
                                                variant: [
                                                    "secondary",
                                                    "blue",
                                                    "offset-left"
                                                ],
                                                href: data.button.href,
                                                children: data.button.label
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    data.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Column__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        spans: isSmallMobile ? 12 : isTablet ? 4 : 6,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().image),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                                // layout={!isSmallMobile && isTablet && 'fill'}
                                // objectFit="cover"
                                // objectPosition={!isSmallMobile && isTablet && 'left'}
                                width: 486,
                                height: 365,
                                alt: "Experience presentation image",
                                src: data.image
                            })
                        })
                    })
                ]
            }),
            data.statistics && !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(data.statistics) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Columns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                variant: [
                    "no-gutter",
                    "-distribute-between"
                ],
                children: data.statistics.map(function(item, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
                        children: [
                            data.statistics && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Column__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                variant: [
                                    "no-padding"
                                ],
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().option),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().option__title),
                                        children: item.value
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().option__subtitle),
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                                        alt: "icon for ".concat(item.value),
                                        src: (0,_helpers_getS3Url__WEBPACK_IMPORTED_MODULE_8__/* .getS3Url */ .v)(item.cloudflare_icon || item.icon),
                                        width: 36,
                                        height: 36
                                    })
                                ]
                            }),
                            isMobile ? index % 2 !== 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().border)
                            }) : index !== 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().border)
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Perks);


/***/ }),

/***/ 23944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/pages/home/Perks/index.js
var Perks = __webpack_require__(51987);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/pages/home/Welcome/styles.module.scss
var styles_module = __webpack_require__(66426);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./components/elements/Container/index.js
var Container = __webpack_require__(51524);
// EXTERNAL MODULE: ./components/elements/DateSearch/index.js + 10 modules
var DateSearch = __webpack_require__(85137);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/elements/Section/index.js
var Section = __webpack_require__(24447);
// EXTERNAL MODULE: ./components/elements/Button/index.js + 2 modules
var Button = __webpack_require__(41197);
// EXTERNAL MODULE: ./components/helpers/getS3Url.js
var getS3Url = __webpack_require__(27895);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/pages/home/Welcome/index.js











var Welcome = function(param) {
    var shadowRef = param.shadowRef, pageData = param.pageData, translations = param.translations, headerTranslation = param.headerTranslation;
    var ref = (0,react.useState)(false), isActive = ref[0], setIsActive = ref[1];
    var router = (0,next_router.useRouter)();
    var propertyTitle = pageData.propertyTitle;
    var propertyBedrooms = pageData.propertyBedrooms;
    var propertyType = pageData.propertyType;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section["default"], {
        variant: [
            "center",
            "z-7"
        ],
        className: (styles_module_default()).welcome,
        bg: pageData.cloudflare_image_section ? (0,getS3Url/* getS3Url */.v)(pageData.cloudflare_image_section, "1980") : (0,getS3Url/* getS3Url */.v)(pageData.image_section),
        cloudflare: pageData.cloudflare_video_section ? (0,getS3Url/* getS3Url */.v)(pageData.cloudflare_video_section, "", true) : false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container["default"], {
                className: (styles_module_default()).welcome__container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).welcome__shadow
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).welcome__content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                dangerouslySetInnerHTML: {
                                    __html: translations.page.welcome.title[router.locale]
                                },
                                className: (styles_module_default()).welcome__title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).welcome__wrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((styles_module_default()).welcome__card, isActive && (styles_module_default()).isActive),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateSearch/* default */.Z, {
                                        setIsActive: setIsActive,
                                        isActive: isActive,
                                        shadowRef: shadowRef,
                                        translations: headerTranslation,
                                        optional: true,
                                        form: [
                                            "dates",
                                            "bedrooms",
                                            "listings"
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                    href: "/real-estate/search",
                                    variant: [
                                        "secondary"
                                    ],
                                    arrow: true,
                                    children: headerTranslation.buyOrSell[router.locale]
                                })
                            })
                        ]
                    })
                ]
            }),
            propertyTitle && propertyBedrooms && propertyType && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).welcome__promo,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/vacation-rentals/".concat(propertyTitle.toLowerCase().replace(/ /g, "-"), "-").concat(propertyBedrooms, "-bedroom-").concat(propertyType),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        children: [
                            translations.page.welcome.featured[router.locale],
                            " ",
                            propertyTitle
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var home_Welcome = (Welcome);

// EXTERNAL MODULE: ./components/templates/Page/index.js + 16 modules
var Page = __webpack_require__(51904);
// EXTERNAL MODULE: ./components/pages/home/Video/styles.module.scss
var Video_styles_module = __webpack_require__(91522);
var Video_styles_module_default = /*#__PURE__*/__webpack_require__.n(Video_styles_module);
;// CONCATENATED MODULE: ./components/pages/home/Video/index.js




var CloudflareVideo = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9562).then(__webpack_require__.bind(__webpack_require__, 69562));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69562)
            ];
        }
    },
    ssr: false
});
var Video_Button = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 41197));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41197)
            ];
        }
    },
    ssr: false
});
var Video = function(param) {
    var pageData = param.pageData, translations = param.translations;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Video_styles_module_default()).video,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudflareVideo, {
                        loop: true,
                        title: "Sxmsir Presentation video",
                        autoplay: true,
                        muted: true,
                        src: pageData.cloudflare_video ? pageData.cloudflare_video : pageData.video
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Video_styles_module_default()).overlay
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Video_styles_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        dangerouslySetInnerHTML: {
                            __html: translations.page.video.title[router.locale]
                        },
                        className: (Video_styles_module_default()).title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Video_Button, {
                        href: "/vacation-rentals",
                        children: translations.page.video.button[router.locale]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var home_Video = (Video);

;// CONCATENATED MODULE: ./pages/index.js



var pages_Section = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 24447));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24447)
            ];
        }
    }
});

var Featured = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6020).then(__webpack_require__.bind(__webpack_require__, 46020));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46020)
            ];
        }
    }
});
var Rentals = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2756), __webpack_require__.e(5798), __webpack_require__.e(5585), __webpack_require__.e(5444), __webpack_require__.e(9325)]).then(__webpack_require__.bind(__webpack_require__, 12943));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12943)
            ];
        }
    }
});
var Experience = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5798), __webpack_require__.e(9348)]).then(__webpack_require__.bind(__webpack_require__, 29348));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29348)
            ];
        }
    }
});
var Reviews = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2756), __webpack_require__.e(5798), __webpack_require__.e(8085), __webpack_require__.e(8693)]).then(__webpack_require__.bind(__webpack_require__, 35842));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35842)
            ];
        }
    }
});






var Home = function(param) {
    var pageData = param.pageData, translations = param.translations, headerTranslation = param.headerTranslation, footerTranslation = param.footerTranslation, ctaTranslation = param.ctaTranslation, recommendedProperties = param.recommendedProperties;
    var shadowRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), shouldLoadPlayer = ref[0], setShouldLoadPlayer = ref[1];
    var containerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        // Store ref value in local variable to ensure consistency
        var element = containerRef.current;
        // Make sure the ref is initialized and points to an actual DOM element
        if (!element || !_instanceof(element, Element)) return;
        var observer = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting) {
                setShouldLoadPlayer(true);
                observer.disconnect();
            }
        }, {
            rootMargin: "200px"
        });
        // Safely observe the element
        observer.observe(element);
        // Clean up function
        return function() {
            observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page["default"], {
        headerTranslation: headerTranslation,
        footerTranslation: footerTranslation,
        translations: translations,
        ctaTranslation: ctaTranslation,
        meta: {
            title: translations.page.seo.title[router.locale],
            description: translations.page.seo.title[router.locale]
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_Welcome, {
                pageData: pageData,
                translations: translations,
                shadowRef: shadowRef,
                headerTranslation: headerTranslation
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_Section, {
                variant: [
                    "white",
                    "o-hidden"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Perks/* default */.Z, {
                    data: {
                        title: translations.page.perks.title[router.locale],
                        description: translations.page.perks.description[router.locale],
                        button: {
                            label: translations.page.perks.button[router.locale],
                            href: "/guest-experience"
                        },
                        image: (pageData === null || pageData === void 0 ? void 0 : pageData.cloudflare_introduction_image) && (0,getS3Url/* getS3Url */.v)(pageData === null || pageData === void 0 ? void 0 : pageData.cloudflare_introduction_image),
                        statistics: pageData.introduction_statistics
                    },
                    shadowRef: shadowRef
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_Section, {
                separator: true,
                variant: [
                    "center",
                    "darker"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Featured, {
                    translations: translations,
                    pageData: pageData
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: containerRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rentals, {
                    properties: recommendedProperties,
                    title: translations.page.rentals.title[router.locale],
                    intro: true,
                    buttonLink: "/vacation-rentals?homeType=exclusive",
                    buttonLabel: translations.page.rentals.button[router.locale],
                    bottomTitle: translations.page.rentals.bottomTitle[router.locale],
                    bottomDescription: translations.page.rentals.bottomDescription[router.locale],
                    cardTranslation: translations.page.rentals
                })
            }),
            shouldLoadPlayer && /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_Section, {
                variant: [
                    "center",
                    "bottom",
                    "p0",
                    "o-hidden"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(home_Video, {
                    pageData: pageData,
                    translations: translations
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_Section, {
                variant: [
                    "white"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Experience, {
                    title: translations.page.experience.title[router.locale],
                    label: translations.page.experience.label[router.locale],
                    description: translations.page.experience.description[router.locale],
                    translations: translations,
                    services: pageData === null || pageData === void 0 ? void 0 : pageData.service
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_Section, {
                variant: [
                    "white",
                    "center",
                    "pt0"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews, {
                    label: translations.page.reviews.label[router.locale],
                    title: translations.page.reviews.title[router.locale],
                    description: translations.page.reviews.description[router.locale],
                    button: translations.page.reviews.getInTouch[router.locale],
                    reviews: pageData.reviews
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 42998:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"separator":"styles_separator__LP5R2","separator--vertical":"styles_separator--vertical__XAMVo","separator--center":"styles_separator--center__qDfXg","separator--full-width":"styles_separator--full-width__WOn53"};

/***/ }),

/***/ 6644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__yHGzn","section__image":"styles_section__image__3wu_0","section__separator":"styles_section__separator__jTwxZ","section__overlay":"styles_section__overlay__S4fzZ","section__video":"styles_section__video__aGMVE","section__video--grayscale":"styles_section__video--grayscale__cSkkv","section--separator-large":"styles_section--separator-large__e2xv7","section--has-separator":"styles_section--has-separator__9vXz9","section--separator-top":"styles_section--separator-top__EcwNQ","section--gray":"styles_section--gray__GL0Sw","section--white":"styles_section--white__NJa_K","section--contained":"styles_section--contained__Laf5M","section--center":"styles_section--center__LmG2q","section--primary":"styles_section--primary__GuN0k","section--darker":"styles_section--darker__uJmer","section--bg-body":"styles_section--bg-body__g_dZD","section--o-hidden":"styles_section--o-hidden__xJTM8","section--with-bg":"styles_section--with-bg__fgmbo","section--pt0":"styles_section--pt0__IoFne","section--full-height":"styles_section--full-height__xFIuY","section--bottom":"styles_section--bottom__hRh3f","section--p0":"styles_section--p0__CiUN0","section--pb0":"styles_section--pb0__OvCBe","section--p-xs":"styles_section--p-xs__AOSqe","section--p-xl":"styles_section--p-xl__9nhJz","section--z-7":"styles_section--z-7__RDdr0"};

/***/ }),

/***/ 87898:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__QeIUJ","border":"styles_border__YCmDs","title":"styles_title__SR5RN","columns":"styles_columns__ccPxT","columns--wide":"styles_columns--wide__6eoCG","image":"styles_image__BHigo","option":"styles_option__KmnIN","option__title":"styles_option__title__5Uf0K","option__subtitle":"styles_option__subtitle__q2E7O","button":"styles_button__yckal"};

/***/ }),

/***/ 91522:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"video":"styles_video__y1jL9","title":"styles_title__H9tS3","content":"styles_content__3X2RF","overlay":"styles_overlay__MxQ_b"};

/***/ }),

/***/ 66426:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"welcome":"styles_welcome__RpQA3","welcome__content":"styles_welcome__content__PRKut","welcome__title":"styles_welcome__title__NoljV","welcome__promo":"styles_welcome__promo__7zeP1","welcome__shadow":"styles_welcome__shadow__5CAdZ","welcome__container":"styles_welcome__container__oNqWZ","welcome__card":"styles_welcome__card__9KU2N","isActive":"styles_isActive__2prtj","welcome__wrapper":"styles_welcome__wrapper__pqvnD"};

/***/ }),

/***/ 36378:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _baseGetTag_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93589);
/* harmony import */ var _isArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27771);
/* harmony import */ var _isObjectLike_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18533);




/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!(0,_isArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value) && (0,_isObjectLike_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value) && (0,_baseGetTag_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(value) == stringTag);
}

/* harmony default export */ __webpack_exports__["Z"] = (isString);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3790,5675,7549,6820,8433,8094,3817,9774,945,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);